import React, { useEffect } from 'react'
import { Row, Select, Divider } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './SelectFieldsStep.module.scss'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import CarSelectFields from './CarSelectFields/CarSelectFields'
import PlaneSelectFields from './PlaneSelectFields/PlaneSelectFields'
import { CustomSelect, CustomTitle, CustomText, CustomCol } from 'src/components'
import ParcelSelectFields from './ParcelSelectFields/ParcelSelectFields'
import { setMassiveCalculationUrl, resetMassiveCalculationKeys } from 'src/features'
const { Option } = Select

const CALCULE_OPTIONS = [
  { url: `${process.env.CALCULATOR_API}/api/v1/calculate/calculate_cars_co2/`, label: 'admin.MassiveCalculate.Cars' },
  { url: `${process.env.CT_CALCULATOR_API}/mobility/air/plane/public/`, label: 'admin.MassiveCalculate.Planes' },
  { url: `${process.env.CT_CALCULATOR_API}/transport/courier/domestic/delivery/massive`, label: 'admin.MassiveCalculate.Parcel' },
]

const SelectFieldsStep = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { calculeUrl } = useAppSelector((state) => state.admin.massiveCalculation)

  useEffect(() => {
    dispatch(setMassiveCalculationUrl(
      calculeUrl !== null ? calculeUrl :
        CALCULE_OPTIONS[0].url)
    )
  }, [dispatch, calculeUrl])

  const onChangeCalculeUrl = (value: string) => {
    dispatch(resetMassiveCalculationKeys())
    dispatch(setMassiveCalculationUrl(value))
  }

  return (
    <>
      <Row>
        <CustomCol>
          <CustomTitle label={t('admin.MassiveCalculate.CalculeType')} type={null} />
          <CustomText  label={t('admin.MassiveCalculate.CalculeTypeLabel')} className={styles['text-margin']}/>
        </CustomCol>
        <CustomCol>
          <CustomSelect
            value={calculeUrl}
            onChange={onChangeCalculeUrl}
            placeholder={t('Select calculus type here...')}
          >
            {CALCULE_OPTIONS.map((item, idx) => (
              <Option value={item.url} key={idx}>{t(item.label)}</Option>
            ))}
          </CustomSelect>
        </CustomCol>
      </Row>
      <Divider className={styles['divider-margin']} />
      {calculeUrl === CALCULE_OPTIONS[0].url && <CarSelectFields />}
      {calculeUrl === CALCULE_OPTIONS[1].url && <PlaneSelectFields />}
      {calculeUrl === CALCULE_OPTIONS[2].url && <ParcelSelectFields />}
    </>
  )
}

export default SelectFieldsStep
